import React from "react";
import headerRight from "../../assets/pcc.png";
import { makeStyles, Button, Typography } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  background: {
    minHeight: "80vh",
    color: "white",
    textShadow: "3px 4px black",
    paddingLeft: 60,
    [theme.breakpoints.down("md")]: {
      minHeight: 500,
      marginTop: 0,
      paddingLeft: 10,
    },
  },
  heading: {
    textAlign: "left",
    fontSize: 44,
    fontWeight: 600,
    verticalAlign: "middle",
    wordSpacing: "0px",
    fontFamily: "Balsamiq Sans",
    lineHeight: "60px",
    // marginTop: 30,
    paddingTop: 150,
    [theme.breakpoints.down("md")]: {
      fontSize: 32,
      lineHeight: "44px",
      paddingTop: 80,
    },
  },
  image: {
    width: "100%",
    marginBottom: 10,

    [theme.breakpoints.down("md")]: {
      width: 350,
      height: "auto",
      marginTop: 5,
      marginBottom: 10,
    },
  },
  subheading: {
    textAlign: "center",
    fontSize: 24,
    fontWeight: 600,
    verticalAlign: "middle",
    wordSpacing: "0px",
    marginTop: 20,
    color: "#F0B90B",
    [theme.breakpoints.down("md")]: {
      marginTop: 20,
      fontSize: 18,
    },
  },
  para: {
    lineHeight: "30px",
    [theme.breakpoints.down("md")]: {
      marginTop: 15,
      fontSize: 14,
    },
  },
  buttonGame: {
    borderRadius: "30px",
    background: `linear-gradient(to right,#6a1b9a, #8e24aa)`,
    lineHeight: "24px",
    verticalAlign: "baseline",
    letterSpacing: "-1px",
    margin: 0,
    marginTop: 15,
    color: "#ffffff",
    padding: "18px 20px 18px 20px",
    fontWeight: 600,
    fontSize: "1.2vw",
    textTransform: "none",
    [theme.breakpoints.down("sm")]: {
      fontSize: 16,
      padding: "12px 15px 12px 15px",
      fontWeight: 500,
    },
  },
  iframeWrapper: {
    display: "block",
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
}));

const HomePage = () => {
  const classes = useStyles();
  return (
    <div className={classes.background}>
      <div className="container">
        <div className="row">
          <div className="col-md-6">
            {" "}
            <Typography variant="h3" className={classes.heading}>
            PEACOCK 2.0 <br />
            (PCC)
            </Typography>
            <Typography variant="body1" className={classes.para}>
            The PEACOCK Protocol is a community driven, fair launched DeFi Token. Three simple functions.
            </Typography>
            <div>
              <a href="https://pancakeswap.finance/swap?inputCurrency=BNB&outputCurrency=0x23799d7F65961334D75e8c87b39A47B00c76fEe2">
                <Button className={classes.buttonGame} variant="contained">
                  BUY $Peacock 2.0
                </Button>
              </a>
            </div>
          </div>
          <div className="col-md-6">
            <div
              style={{
                minHeight: 480,
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-end",
                alignItems: "center",
              }}
            >
              <h5>How to Stake VIT earn PCC!</h5>

              <div
                style={{
                  borderRadius: 7,
                  border: "3px solid #ffffff",
                  width: "100%",
                }}
              >
                <img className={classes.image} src={headerRight} />
		{/*<iframe
                  width="100%"
                  height="315"
                  src=""
                  title="YouTube Celeng"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                ></iframe>

              */}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePage;
